import React, { useState, useContext } from "react";
import { connect } from "react-redux";
import CustomModal from "./CustomModal";
import Button from "../atoms/Button";

import { getPrice, sendDataLayer } from "../../utils/functions";
import { doloadRedeem } from "../../utils/helpers";
import { StateController } from "./../../App";

function AwardBox({
  index,
  type,
  award,
  canRedem,
  redemtionText,
  token,
  download,
  twoStepAuth,
  termLink,
  termText,
  textTitle,
  segment,
  idmask
}) {
  const { setAwardSelected, handlerRootModal } = useContext(StateController);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [showErrorDownload, setShowErrorDownload] = useState(false);
  const [showErrorRedemtion, setShowErrorRedemtion] = useState(false);

  const handlerModal = () => {
    if (!download) {
      sendDataLayer({
        datalayer: {
          event: "bond_interest",
          product_name: award?.name,
          product_price: award?.price,
          index: index + 1,
        },
        repeat: true,
      });
    }

    if (download && !downloadLoading) {
      console.log("Redencion:", award);
      setDownloadLoading(true);
      sendDataLayer({datalayer: {event: 'redownload', product_name: award.name, product_price: award.price, product_type: "inteligentes", text_title: textTitle, segment: segment, index: 0, idmask: idmask},repeat: true})
      doloadRedeem(award.id, token)
        .then((data) => {
          console.log("result download:", data);
          setDownloadLoading(false);

          if (data && (data.status === 402 || data.status === 400)) {
            setShowErrorDownload(true);
          }
        })
        .catch((error) => {
          console.log("ERROR DOWNLOAD REDENTION:", error);
          setDownloadLoading(false);
          setShowErrorDownload(true);
        });
    } else {
      if (canRedem) {
        handlerRootModal();
        setAwardSelected({
          image: award.image,
          price: award.price,
          name: award.name,
          canRedem: canRedem,
          id: award.id,
          location: award.location,
          brand_id: award.idbrand,
          twoStepAuth: twoStepAuth,
          index: index + 1,
        });
      }
    }
  };

  return (
    <div className="mc-awards-container__items--item__container">
      <CustomModal
        title="Error en la descarga"
        desc={
          "Ocurrió un error al obtener tu bono. Intentalo de nuevo más tarde."
        }
        cta="Aceptar"
        image="image.png"
        show={showErrorDownload}
        setShowModal={setShowErrorDownload}
      />
      <CustomModal
        title="Error en la redención"
        desc={
          "Ocurrió un error al obtener tu bono. Intentalo de nuevo más tarde."
        }
        cta="Aceptar"
        image="image.png"
        show={showErrorRedemtion}
        setShowModal={setShowErrorRedemtion}
      />
      {type === 3 && (
        <>
          <div className={`mc-awards-container__items--item__info download`} >
            <div className="mc-awards-container__items--item__image">
              <img src={`/assets/images/${award.image}`} alt='logo'/>
            </div>
            <div className="mc-awards-container__items--item__labels">
              <div className="mc-awards-container__items--item__name">
                {award.name}
              </div>
              <div className="mc-awards-container__items--item__price">
                {getPrice(award.price)}
              </div>
            </div>
          </div>
          <div className="mc-awards-container__items--item__actions">
            {termLink && (
              <p>
                <a href={termLink} target="_blank" rel="noreferrer"
                  onClick={() => {
                    sendDataLayer({
                      datalayer: {
                        event: "bonus_terms",
                        text: termText
                      },
                      repeat: true,
                    });
                  }}
                >
                  {termText}
                </a>
              </p>
            )}
            <Button
              type="secondary"
              text={redemtionText}
              loading={downloadLoading}
              status={canRedem ? 'active' : 'inactive'}
              onClick={(e) => handlerModal(e,)}
              icon={download ? 'download' : canRedem ? false : 'secure'}
            />
          </div>
        </>
      )}
    </div>
  );
}

const mapState = ({ user: { token } }) => {
  return {
    token,
  };
};

export default connect(mapState)(AwardBox);
